import { FaCaretDown } from "react-icons/fa";

import { Collapsible } from "shared/ui/collapsible";

import { Section } from "../section";

const items = [
  {
    title: "Bento?",
    content: `Bento is a decentralized, permissionless protocol powering Bento
          Dollar (beUSD) — a digital dollar purpose-built for savings, optimized
          for capital preservation and superior risk-adjusted yields. For more
          details, visit the Bento Docs.`,
  },
  {
    title: "What is Wasabi Farming Season 0?",
    content: `Wasabi Farming Season 0 is the first step in our journey toward the mainnet deployment. This pre-launch, pre-deposit phase is designed to kickstart our platform, onboard stablecoin liquidity, and introduce the Bento points program. Users who participate in Season 0 receive boosted Wasabi and yield by depositing a range of stablecoins.`,
  },
  {
    title: "What are bentoUSD and bentoUSD+?",
    content: `bentoUSD is the receipt token for depositing stabelcoins in Wasabi Points Farm and holders earn boosted Wasabi points and other rewards.\n\nbentoUSD+ is the receipt token for depositing stabelcoins in Bento Yield Farm and holders earn boosted real yield from the underlying stablecoins.`,
  },
  {
    title: "Which assets can be deposited in Wasabi Season 0?",
    content: "HARDCODE",
  },
  {
    title: "Is there a lock‑up period?",
    content:
      "No, withdrawals can be made at any time  — instantly and without any lock-up.",
  },
  {
    title: "How long is Season 0 expected to run?",
    content: `Season 0 is expected to run until the launch of the Bento protocol with Bento Dollar (beUSD), and we aim to conclude it within three months of launching pre-deposits.`,
  },
];

export const FAQSection = () => {
  return (
    <Section className="max-w-2xl flex-col md:flex-col">
      <Section.Title className="text-[34px] leading-[105%] font-semibold md:text-[42px]">
        Everything You Need To Know
      </Section.Title>
      <div className="mt-10 flex flex-col gap-1.5">
        {items.map((item) => {
          return (
            <Collapsible
              defaultOpen={item.content === "HARDCODE"}
              key={item.title}
              className="bg-baltic-sea/30 w-full rounded-xl pb-4.5"
            >
              <Collapsible.Trigger className="flex w-full cursor-pointer items-center justify-between gap-x-2 px-4.5 pt-4.5 text-left text-xl leading-[105%] font-semibold outline-hidden">
                {item.title}
                <span className="text-nobel flex size-7.5 shrink-0 cursor-pointer items-center justify-center rounded-[10px] bg-white/10 outline-hidden transition-colors group-hover:brightness-125">
                  <FaCaretDown className="size-4 transition-transform group-data-[state=open]:rotate-180" />
                </span>
              </Collapsible.Trigger>
              <Collapsible.Content className="">
                <div className="text-nobel flex px-4.5 pt-4.5 leading-[150%] font-normal whitespace-pre-line">
                  {item.content}
                </div>
              </Collapsible.Content>
            </Collapsible>
          );
        })}
      </div>
    </Section>
  );
};
